import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";


export interface IDiagnosisAI {
    diagnostico: string;
    consideraciones: string;
    examenes: string[];
    acciones_inmediatas: string[];
    descargo_de_responsabilidad: string;
}

@Injectable({
    providedIn: 'root',
})
export class SophiaAgentAIService {
    private readonly httpClient = inject(HttpClient);

    getDiagnosis(idAgendamiento: string, idPaciente: string): Observable<IDiagnosisAI> {
        return this.httpClient.get<IDiagnosisAI>(
            `${environment.sophiaAgentAIUrl}/v1/ai/diagnosis/${idAgendamiento}/${idPaciente}`
        );
    }
}